import script from "./OverlayCart.vue?vue&type=script&setup=true&lang=ts"
export * from "./OverlayCart.vue?vue&type=script&setup=true&lang=ts"

import "./OverlayCart.vue?vue&type=style&index=0&id=1d993250&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d993250"]])

export default __exports__